import * as React from 'react';

import { useQuery } from '@apollo/client';
import { uniq } from 'lodash';

import CourseRow from 'bundles/internal-enterprise/components/CourseRow';
import coursePartitionQuery from 'bundles/internal-enterprise/queries/CoursePartition.graphql';
import type {
  CoursePartitionQuery,
  CoursePartitionQueryVariables,
} from 'bundles/internal-enterprise/queries/__generated__/CoursePartition';
import type { EnrollItem } from 'bundles/internal-enterprise/types/Program';

type PropsFromCaller = {
  programS12nIds: Array<string>;
  programId: string;
  userId: string;
  courseItems: Array<EnrollItem>;
};

const CoursePartition = ({ courseItems, programId, userId, programS12nIds }: PropsFromCaller) => {
  const courseIds = uniq(courseItems.map((item) => item.id));
  const { data } = useQuery<CoursePartitionQuery, CoursePartitionQueryVariables>(coursePartitionQuery, {
    variables: {
      ids: courseIds,
    },
    context: { clientName: 'gatewayGql' },
  });
  const courses = data?.Course?.queryByIds ?? [];
  return (
    <div className="row-block">
      {courses.map((course) => {
        const courseItem = courseItems.find((item) => item.id === course.id);
        const s12nSlugs = course.specializations.filter((_) => programS12nIds.includes(_.id)).map((s12n) => s12n.slug);
        return (
          <CourseRow
            key={course.id}
            course={course}
            enrolled={courseItem !== undefined ? courseItem.enrolled : false}
            s12nSlugs={s12nSlugs}
            programId={programId}
            userId={userId}
          />
        );
      })}
    </div>
  );
};

export default CoursePartition;
